import { ActionContext } from "vuex";

import { RootState } from "@/stores";
import {
  UpdateCredentialsRequest,
  IntegrationsPayload,
  Integrations,
  UpdateIntegrationPayload,
} from "@/types";
import BankIntegrationService from "@/services/bank-integrations";

import { IntegrationsState } from "./index";

export async function getIntegrations(
  { rootState }: ActionContext<IntegrationsState, RootState>,
  payload: IntegrationsPayload
): Promise<Integrations> {
  const {
    auth,
    config: { serviceUrl },
  } = rootState;

  const result = await new BankIntegrationService(
    serviceUrl,
    auth.auth?.id_token as string
  ).getIntegrations(payload);

  return result;
}

export async function updateIntegrationStatus(
  { rootState }: ActionContext<IntegrationsState, RootState>,
  payload: UpdateIntegrationPayload
): Promise<any> {
  const {
    auth,
    config: { serviceUrl },
  } = rootState;

  const result = await new BankIntegrationService(
    serviceUrl,
    auth.auth?.id_token as string
  ).updateIntegrationStatus(payload);

  return result;
}

export async function updateFIService(
  { rootState }: ActionContext<IntegrationsState, RootState>,
  { id, payload }: { id: string; payload: UpdateCredentialsRequest }
): Promise<void> {
  const {
    auth,
    config: { serviceUrl },
  } = rootState;

  await new BankIntegrationService(
    serviceUrl,
    auth.auth?.id_token as string
  ).updateFIService(id, payload);
}
